<template>
  <div>
        <SearchForInvoice
        ></SearchForInvoice>
  </div>
</template>

<script>
  import SearchForInvoice from "../../util/Invoices/SearchForInvoice";

  export default {
    name: "InvoicesUI",
    components: {SearchForInvoice},
    methods: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/InvoicesUI.vue